module.exports = __webpack_public_path__ + "img/miyama2.628ef474.jpg";